import * as React from 'react';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import './PreventDownload.scss';
import stringsResx from '../../Share.resx';
import { TooltipHost, DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';
import * as StringHelper from '@ms/odsp-utilities/lib/string/StringHelper';
import { ClientId, Mode } from "../../../interfaces/SharingInterfaces";
import * as PropTypes from 'prop-types';

export interface IPreventDownloadState {
  preventDownloadToggle: boolean;
}

export interface IPreventDownloadProps {
  onToggleChange?: (value: boolean) => void;
  isToggled: boolean;
  disablePreventDownload: boolean;
  detailsPane?: boolean;
  clientId: ClientId;
  mode: Mode;
}

export class PreventDownload extends React.Component<IPreventDownloadProps, IPreventDownloadState> {
  static contextTypes = {
    sharingStore: PropTypes.object.isRequired
  };

  constructor(props: IPreventDownloadProps, context: any) {
    super(props);
    this.state = {
      preventDownloadToggle: false
    };

    this._onChanged = this._onChanged.bind(this);
  }

  public render(): React.ReactElement<{}> {
    // Toggle when not disabled and already checked.
    const isDisabled = this.props.disablePreventDownload;
    let isToggled = (!isDisabled && this.props.isToggled);
    const showTooltip = !this.props.detailsPane && this.props.disablePreventDownload;
    const ariaLabel = showTooltip ? StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) : stringsResx.preventDownloadLabel;

    // Details pane always renders PreventDownload as disabled and checked.
    if (this.props.detailsPane) {
      isToggled = true;
    }

    return (
      <div className='od-PreventDownloadToggle'>
        <div className='od-PermissionsSettings-setting--PreventDownload-Icon'>
          <Icon iconName='Blocked2' { ...{ alt: stringsResx.imageAltPreventDownloadIcon } } />
        </div>
        <Toggle
          checked={ isToggled }
          disabled={ isDisabled }
          label={ stringsResx.preventDownloadLabel }
          ariaLabel={ ariaLabel }
          onChanged={ this._onChanged }
        />
        { showTooltip &&
          <div className='od-PreventDownloadToggle--info' aria-label={ StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) }>
            <TooltipHost
              hostClassName='od-preventDownload-tooltip'
              content={ StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) }
              directionalHint={ DirectionalHint.topCenter }
              calloutProps={ { gapSpace: 0 } }
              tooltipProps={ { maxWidth: '300px' } }
            >
              <div
                tabIndex={ 0 }
                className='od-preventDownload-tooltipWrapper'
              >
                <div className='od-preventDownload-hidden' aria-label={ StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) }>
                  { StringHelper.format(stringsResx.preventDownloadInfoIcon, stringsResx.allowEditLabel) }
                </div>
                <Icon aria-hidden='true' iconName={ 'Info' } className={ 'ms-Icon ms-Icon--Info' } />
              </div>
            </TooltipHost>
          </div> }
      </div>
    );
  }

  private _onChanged(value: boolean): void {

    this.context.sharingStore.getEngagementHelper().log(
      'PreventDownload.ToggleChanged',
      {
        clientId: this.props.clientId,
        scenarioId: '',
        mode: this.props.mode
      }
    );

    this.setState({
      preventDownloadToggle: value
    }, () => {
      this.props.onToggleChange(value);
    });
  }
}